import { render, staticRenderFns } from "./EstablishmentList.vue?vue&type=template&id=d5117d66"
import script from "./EstablishmentList.vue?vue&type=script&lang=js"
export * from "./EstablishmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports